import { showDemoDataSelectors } from '@/redux/selectors';
import { useAppSelector } from '@/redux/hooks';

import { AddressHistory, Preferences } from './components';
import { ThisIsDemoData } from '../ThisIsDemoData';

export const ComplianceDashboardAddressesMonitoring = () => {
  const isShowDemoData = useAppSelector(showDemoDataSelectors.byMonitoring);

  return (
    <>
      {isShowDemoData && <ThisIsDemoData />}
      <Preferences />
      <AddressHistory />
    </>
  );
};
